import { render, staticRenderFns } from "./applyLive.vue?vue&type=template&id=860fb19a&scoped=true"
import script from "./applyLive.vue?vue&type=script&lang=js"
export * from "./applyLive.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./applyLive.vue?vue&type=style&index=1&id=860fb19a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860fb19a",
  null
  
)

export default component.exports